import { useState } from "react";
import { useNavigate } from "react-router-dom";

import "../landing/landing.css";
import { Navbar } from "../landing/components/Navbar";
import { Hero } from "../landing/components/Hero";
import { AboutSection } from "../landing/components/AboutSection";
import { ServicesSection } from "../landing/components/ServicesSection";
import { WhyChooseUs } from "../landing/components/WhyChooseUs";
import { ContactSection } from "../landing/components/ContactSection";
import { Footer } from "../landing/components/Footer";
import { PoliciesModal } from "../landing/components/PoliciesModal";

export default function Home() {
    const navigate = useNavigate();
    const [activePolicyModal, setActivePolicyModal] = useState(null);

    // /signin does not bounce an already-authenticated visitor, so send them
    // straight to the dashboard instead of showing the login form again.
    const isSignedIn = Boolean(localStorage.getItem("accessToken"));

    const scrollToSection = (sectionId) => {
        const el = document.getElementById(sectionId);
        if (el) {
            el.scrollIntoView({ behavior: "smooth" });
        }
    };

    const goToSignIn = () => navigate(isSignedIn ? "/dashboard" : "/signin");

    return (
        <div className="gb-landing min-h-screen bg-white text-slate-900 flex flex-col font-['Plus_Jakarta_Sans',sans-serif] antialiased">
            {/* Navigation: Home, About Us, Services, Payment Solutions, Why Choose Us, Contact Us + Login */}
            <Navbar
                onSignIn={goToSignIn}
                signInLabel={isSignedIn ? "Dashboard" : "Login"}
                onContactClick={() => scrollToSection("contact-section")}
            />

            <main className="grow">
                {/* Hero Section */}
                <Hero
                    onExploreServices={() => scrollToSection("services-section")}
                    onContactClick={() => scrollToSection("contact-section")}
                    onSignIn={goToSignIn}
                />

                {/* About Us Section */}
                <AboutSection
                    onContactClick={() => scrollToSection("contact-section")}
                    onServicesClick={() => scrollToSection("services-section")}
                />

                {/* Services & Payment Solutions */}
                <ServicesSection
                    onSignIn={goToSignIn}
                    onContactClick={() => scrollToSection("contact-section")}
                />

                {/* Why Choose Us: Speed, 256-Bit SSL, 24/7 Support, Success */}
                <WhyChooseUs
                    onContactClick={() => scrollToSection("contact-section")}
                />

                {/* Contact Us: Hyderabad Office, Phone, Email, Inquiries */}
                <ContactSection />
            </main>

            {/* Footer */}
            <Footer onOpenPolicy={(type) => setActivePolicyModal(type)} />

            {/* Legal & Compliance Policies Modal */}
            <PoliciesModal
                initialType={activePolicyModal || "privacy"}
                isOpen={activePolicyModal !== null}
                onClose={() => setActivePolicyModal(null)}
            />
        </div>
    );
}
